import Skeleton from '@mui/material/Skeleton';
import { Box } from 'shared/mui/Box';

import { OrderProviderExternalErrorsRatioChartBarTitle } from './OrderProviderExternalErrorsRatioChart.styled';

export const OrderProviderExternalErrorsRatioChartBarSkeleton: React.FC = () => (
  <Box>
    <OrderProviderExternalErrorsRatioChartBarTitle>
      <Skeleton sx={{ fontSize: '12px' }} variant="text" width="40%" />
      <Skeleton sx={{ fontSize: '12px' }} variant="text" width="30%" />
    </OrderProviderExternalErrorsRatioChartBarTitle>
    <Skeleton height={8} variant="rectangular" />
  </Box>
);
